import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { CourseAssignment } from './@types';
import { StageCompletionRecord } from './get-course-assignment-details';

export type CourseAssignmentOperatorDetails = {
   authorInfo: {
      userid: number;
      username: string;
      url: string;
   };
   courseAssignment: Omit<CourseAssignment, 'user_completion_status' | 'completionTotals'> & {
      user_completion_status: StageCompletionRecord[];
   };
};

export async function getCourseAssignmentOperatorDetails(
   courseAssignmentId: number | null,
   common: CommonRequestOptions = {}
): Promise<CourseAssignmentOperatorDetails> {
   return makeRequest(
      'get',
      `course_assignments/courseAssignmentDetails/${courseAssignmentId}`,
      common
   );
}
